// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"20e113ac","554":"3fbc1b7c","657":"e15e29e0","898":"a2d4585a"}[chunkId] + ".chunk.js";
};